<div *ngIf="!isLoading" class="zk-relative">
	<div class="header zk-flex zk-justify-between zk-items-center">
		<div>
			<span>Meus dados</span>
		</div>
		<div *ngIf="userIsPremium" class="link-analytics">
			<span *unleash="'insightsv2'" id="go-to-insights" (click)="goToInsights()">Ir para Desempenho <span class="freud-icon freud-icon-md freud-icon-arrow-right"></span></span>
		</div>
	</div>
	<iframe
		#iframeRef
		id="looker-iframe"
		class="mainFrame"
		*ngIf="!isSupersetEnabled"
		[src]="iframeUrl | safe: 'resourceUrl'"
		style="width: 100%; height: 350px; margin-bottom: 20px;"
	>
	</iframe>
	<div *ngIf="dashboard && isSupersetEnabled && userIsPremium" style="width: 100%; height: 350px; margin-bottom: 20px; padding-top: 50px;">
		<superset-embed
			[dashboard]="dashboard"
			heightIframePx="350"
		></superset-embed>
	</div>
</div>
